import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  EventListContainer,
} from '@fuww/library/src/Events';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import SearchBox from './SearchBox';
import EventList from './EventList';
import debouncedReplaceRoute from '../../lib/debouncedReplaceRoute';
import messages from '../../lib/messages.mjs';
import { saveRouterState } from '../../lib/savedRouterState';

const Search = ({ now: nowProperty }) => {
  const intl = useIntl();
  const { query: { search: searchParameter } } = useRouter();
  const [search, setSearch] = useState(searchParameter || '');
  const [now] = useState(new Date(nowProperty));
  const eventsPath = intl.formatMessage(messages.eventsPath);
  const { query } = useRouter();

  useEffect(() => debouncedReplaceRoute('events', {
    eventsPath,
    ...(search ? { search } : {}),
  }), [search, eventsPath]);

  useEffect(() => {
    saveRouterState('events', { query });
  }, [query]);

  return (
    <>
      <SearchBox
        value={search}
        onChange={({ target: { value } }) => setSearch(value)}
        onClear={useCallback(() => setSearch(''), [setSearch])}
      />
      <EventListContainer>
        <EventList variables={{ search: searchParameter || '', now }} />
      </EventListContainer>
    </>
  );
};

Search.propTypes = {
  now: PropTypes.string.isRequired,
};

export default Search;
